import api from "./apiV1";

export const getPublicEntities = () => {
  return api.request("public-entities-points");
};
